<template>
  <div :class="['container', _isMobile() ? 'mobile' : '']">
    <menuList />
    <Header />
    <div class="home">
      <router-view />
    </div>
    <Footer  />
  </div>
</template>

<script>
import { mixinDevice } from "@/utils/mixin.js";
import Header from "../components/Header";
import menuList from "../components/menuList";
import Footer from "../components/Footer.vue";
export default {
  name: "HomeLayout",
  mixins: [mixinDevice],
  components: {
    Header,
    menuList,
    Footer
  },
  data() {
    return {
    };
  },
  created() {
  },
};
</script>
<style lang="less" scoped>
.container {
  .banner-wrap {
   padding: 80px 0;
    background: #24A6E9;
    .banner-bg{
      position: absolute;
      width: 100%;
    }
    .banner {
      margin: auto;
      max-width: 1200px;
      overflow: hidden;
      border-radius: 28px;
      box-shadow: 0px 6px 10px #0303031f;
    }
  }
  .home {
    width: 100%;;
    // margin: 20px auto;
    // padding: 20px 10px;
    background: #ffffff4a;
    display: flex;
    align-items: self-start;
    justify-content: flex-start;
    .pageLeft{
      width: 180px;
      height: calc(100vh - 75px);
      background: #fff;
    }
    // border-radius: 30px;
  }
  /deep/.ant-list-pagination {
    text-align: center;
  }
  // background: url(~@/assets/background.svg);
}
</style>